import {alias, createModelSchema} from "serializr";
import {Schema} from "@/common/Schema";

import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {FireflyKind} from "../../firefly/FireflyKind";
import {RewardModel} from "../../reward/RewardModel";

export class SmartOfferBundleFirefly extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.FIREFLY);

        this._firefly = null;
        this._delayTime = 0;
        this._resetTime = 1;
        this._cooldown = 0;

        this._density = "1*D(3)+2";
        this._interval = "1*D(3)+2";
        this._quantity = "1*D(3)+2";
        this._reward = null;
    }

    get firefly() {
        return this._firefly;
    }

    set firefly(value) {
        this._firefly = value;
    }

    get delayTime() {
        return this._delayTime;
    }

    set delayTime(value) {
        this._delayTime = value;
    }

    get resetTime() {
        return this._resetTime;
    }

    set resetTime(value) {
        this._resetTime = value;
    }

    get cooldown() {
        return this._cooldown;
    }

    set cooldown(value) {
        this._cooldown = value;
    }

    get density() {
        return this._density;
    }

    set density(value) {
        this._density = value;
    }

    get interval() {
        return this._interval;
    }

    set interval(value) {
        this._interval = value;
    }

    get quantity() {
        return this._quantity;
    }

    set quantity(value) {
        this._quantity = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    valid() {
        if (!super.valid()) {
            return false;
        }

        if (!FireflyKind.is(this.firefly) || FireflyKind.isNone(this.firefly)) {
            return false;
        }

        if (!Number.isInteger(this.delayTime) || this.delayTime < 0) {
            return false;
        }

        if (!Number.isInteger(this.resetTime) || this.resetTime <= 0) {
            return false;
        }

        if (!Number.isInteger(this.cooldown) || this.cooldown < 0) {
            return false;
        }

        if (this.density === "") {
            return false;
        }

        if (this.interval === "") {
            return false;
        }

        if (this.quantity === "") {
            return false;
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        return true;
    }

    empty() {
        if (super.empty()) {
            return true;
        }

        return !this.reward || this.reward.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleFirefly());
        } else if (target instanceof SmartOfferBundleFirefly) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleFirefly, {
    _firefly: alias("firefly", FireflyKind.schema()),
    _delayTime: alias("delay_time", Schema.primitive()),
    _resetTime: alias("reset_time", Schema.primitive()),
    _cooldown: alias("cooldown", Schema.primitive()),
    _reward: alias("reward", RewardModel.schema()),

    _density: alias("fn_density", Schema.primitive()),
    _interval: alias("fn_interval", Schema.primitive()),
    _quantity: alias("fn_quantity", Schema.primitive())
});